module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "wx_connection",
    attrs: {
      "title": "绑定微信号",
      "size": "tiny",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": '//qrcode.ppj.io/' + _vm.wxConnection.url
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("扫码绑定微信号")])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad83cf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/account/wx_connection.dialog.vue
// module id = 948
// module chunks = 3